import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/21logo.jpg";
import { FaCartShopping } from "react-icons/fa6";
import { CartContext } from "../CartContext";
import CartProduct from "./CartProduct";
import { BsCartX } from "react-icons/bs";
import { FaShoppingBag, FaTruck } from "react-icons/fa";

const transportInfo = [
  {
    flag: "🇽🇰",
    title: "Kosovë",
    text: "Transporti është falas për të gjitha porositë dhe dërgesa arrin brenda 1–2 ditëve të punës.",
  },
  {
    flag: "🇦🇱🇲🇰",
    title: "Shqipëri & Maqedoni e Veriut",
    text: "Kostoja e transportit është 3€, ndërsa porosia arrin brenda 4–5 ditëve të punës.",
  },
  {
    flag: "💳",
    title: "Pagesa në Dorëzim",
    text: "Pagesën e bëni vetëm pasi ta pranoni porosinë nga postieri ose korrieri (Cash on Delivery).",
  },
  {
    flag: "📦",
    title: "Kontrolloni Porosinë Para Pagesës",
    text: "Ju mund ta hapni dhe ta kontrolloni porosinë para pagesës. Produktet që pranoni janë saktësisht ato që shfaqen në fotografitë e faqes sonë, pa asnjë ndryshim në përmbajtje apo paketim.",
  },
  {
    flag: "🤝",
    title: "Blerje e Sigurt",
    text: "Ne kujdesemi që çdo porosi të dërgohet me siguri dhe në gjendje perfekte, për një eksperiencë sa më të mirë blerjeje.",
  },
];

const Navbar = () => {
  const cart = useContext(CartContext);
  const [toggle, setToggle] = useState(false);
  const handleToggle = () => setToggle(!toggle);
  const [activeTab, setActiveTab] = useState("home");
  const location = useLocation();
  const pathname = location.pathname;
  const [modal, setModal] = useState(false);
  const [transportModal, setTransportModal] = useState(false);
  const productsCount = cart.items.reduce(
    (sum, product) => sum + product.quantity,
    0,
  );

  useEffect(() => {
    if (pathname === "/") {
      setActiveTab("home");
    } else if (pathname === "/produktet") {
      setActiveTab("produktet");
    } else if (pathname === "/kontakti") {
      setActiveTab("kontakti");
    }
  }, [pathname]);

  // Close modals when navigating
  useEffect(() => {
    setModal(false);
    setTransportModal(false);
  }, [pathname]);

  // Lock body scroll when any modal is open
  useEffect(() => {
    if (modal || transportModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [modal, transportModal]);

  return (
    <Container>
      <Link to={"/"} className="link-styles">
        <img src={logo} alt="" className="logo" />
      </Link>

      {/* Desktop & mobile slide-out nav */}
      <ul className={toggle ? "nav-menu active" : "nav-menu"}>
        <Link to={"/"} className="link-styles" onClick={() => setToggle(false)}>
          <li className={activeTab === "home" ? "activeTab" : "nonActive"}>
            Home
          </li>
        </Link>

        <Link
          to={"/produktet"}
          className="link-styles"
          onClick={() => setToggle(false)}
        >
          <li className={activeTab === "produktet" ? "activeTab" : "nonActive"}>
            Produktet
          </li>
        </Link>

        <Link
          to={"/kontakti"}
          className="link-styles"
          onClick={() => setToggle(false)}
        >
          <li className={activeTab === "kontakti" ? "activeTab" : "nonActive"}>
            Kontakti
          </li>
        </Link>

        <li
          className="nonActive transport-btn"
          onClick={(e) => {
            e.stopPropagation();
            setTransportModal(true);
            setModal(false);
            setToggle(false);
          }}
        >
          Transport
        </li>

        <li className="cart-item">
          <FaCartShopping
            onClick={(e) => {
              e.stopPropagation();
              setModal(!modal);
              setTransportModal(false);
              setToggle(false);
            }}
            className="cart"
          />
          {productsCount > 0 && (
            <span className="cart-badge">{productsCount}</span>
          )}
        </li>
      </ul>

      {/* Mobile top-right icons (visible when nav is closed) */}
      <div className="mobile-icons">
        <div className="cart-wrapper">
          <FaCartShopping
            onClick={() => {
              setModal(!modal);
              setTransportModal(false);
            }}
            className="cart-icon"
          />
          {productsCount > 0 && (
            <span className="cart-badge">{productsCount}</span>
          )}
        </div>
        <div className="mobile-menu" onClick={handleToggle}>
          {toggle ? <FaTimes className="icon" /> : <FaBars className="icon" />}
        </div>
      </div>

      {/* Backdrop for modals */}
      {(modal || transportModal) && (
        <div
          className="backdrop"
          onClick={() => {
            setModal(false);
            setTransportModal(false);
          }}
        />
      )}

      {/* Cart Modal */}
      <div className={modal ? "side-modal" : "side-modal closed"}>
        <div className="modal-header">
          <div className="modal-title">
            <FaShoppingBag className="icon" />
            <h3>Shporta jote ({productsCount})</h3>
          </div>
          <button className="close-btn" onClick={() => setModal(false)}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          {productsCount !== 0 ? (
            <div className="item">
              {cart.items.map((currentProduct, idx) => (
                <CartProduct
                  key={idx}
                  id={currentProduct.id}
                  quantity={currentProduct.quantity}
                  title={currentProduct.title}
                />
              ))}
            </div>
          ) : (
            <div className="emptyCart">
              <BsCartX className="cartIcon" />
              <h3>Shporta juaj aktualisht është bosh.</h3>
            </div>
          )}
        </div>

        {productsCount !== 0 && (
          <div className="modal-footer">
            <h2 className="totalPrice">
              Çmimi total: {cart.getTotalCost().toFixed(2)} €
            </h2>
            <Link to={"/checkout"} className="link-styles">
              <button onClick={() => setModal(false)}>Checkout</button>
            </Link>
          </div>
        )}
      </div>

      {/* Transport Modal */}
      <div className={transportModal ? "side-modal" : "side-modal closed"}>
        <div className="modal-header">
          <div className="modal-title">
            <FaTruck className="icon" />
            <h3>Transporti &amp; Pagesa</h3>
          </div>
          <button
            className="close-btn"
            onClick={() => setTransportModal(false)}
          >
            <FaTimes />
          </button>
        </div>

        <div className="modal-body transport-body">
          {transportInfo.map((item, idx) => (
            <div className="transport-card" key={idx}>
              <div className="transport-card-header">
                <span className="transport-flag">{item.flag}</span>
                <h4>{item.title}</h4>
              </div>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  background: #ffffff47;
  transition: 0.4s;
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4%;
  width: 100%;
  height: 70px;
  z-index: 200;
  box-sizing: border-box;
  color: #464646;

  /* ── Logo ── */
  .logo {
    width: 55px;
    border-radius: 50%;
    display: block;
  }

  /* ── Nav menu ── */
  .nav-menu {
    display: flex;
    gap: 32px;
    list-style: none;
    align-items: center;
    margin: 0;
    padding: 0;

    li,
    .transport-btn {
      color: #535353;
      font-weight: 400;
      transition: 0.3s;
      cursor: pointer;
      font-size: 15px;
      :hover {
        color: var(--fontPrimaryColor);
      }
    }

    .activeTab {
      text-decoration: underline;
      text-underline-offset: 7px;
      font-weight: 600;
    }

    .cart-item {
      position: relative;
      display: flex;
      align-items: center;
    }

    .cart {
      font-size: 1.7em;
      cursor: pointer;
      transition: 0.3s;
      :hover {
        color: var(--fontPrimaryColor);
      }
    }

    .cart-badge {
      position: absolute;
      top: -6px;
      right: -8px;
      background: #c0392b;
      color: white;
      font-size: 10px;
      font-weight: 600;
      width: 17px;
      height: 17px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
    }
  }

  /* ── Mobile icons (cart + hamburger) shown on small screens ── */
  .mobile-icons {
    display: none;
    align-items: center;
    gap: 16px;
    z-index: 201;

    .cart-wrapper {
      position: relative;
      display: flex;
      align-items: center;

      .cart-icon {
        font-size: 1.6em;
        cursor: pointer;
        color: var(--fontPrimaryColor);
        transition: 0.3s;
      }

      .cart-badge {
        position: absolute;
        top: -6px;
        right: -8px;
        background: #c0392b;
        color: white;
        font-size: 10px;
        font-weight: 600;
        width: 17px;
        height: 17px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
      }
    }

    .mobile-menu {
      font-size: 22px;
      cursor: pointer;
      color: var(--fontPrimaryColor);
      transition: 0.3s;
      display: flex;
      align-items: center;
      :hover {
        transform: scale(1.1);
      }
    }
  }

  /* ── Backdrop ── */
  .backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 198;
    animation: fadeIn 0.25s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* ── Shared side modal ── */
  .side-modal {
    position: fixed;
    top: 0;
    right: 0;
    height: 100dvh; /* dynamic viewport height — avoids mobile browser chrome overlap */
    width: 400px;
    max-width: 92vw;
    background: #012b16;
    color: white;
    z-index: 199;
    display: flex;
    flex-direction: column;
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.35);
    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(0);

    &.closed {
      transform: translateX(110%);
      pointer-events: none;
    }

    /* Header */
    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 18px 16px 14px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      flex-shrink: 0;

      .modal-title {
        display: flex;
        align-items: center;
        gap: 12px;
        .icon {
          color: white;
          font-size: 1.2em;
        }
        h3 {
          margin: 0;
          font-weight: 400;
          font-size: 16px;
        }
      }

      .close-btn {
        background: rgba(255, 255, 255, 0.1);
        border: none;
        color: white;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
        transition: 0.2s;
        flex-shrink: 0;
        :hover {
          background: rgba(255, 255, 255, 0.2);
        }
      }
    }

    /* Scrollable body */
    .modal-body {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      -webkit-overflow-scrolling: touch;

      /* Scrollbar styling */
      ::-webkit-scrollbar {
        width: 4px;
      }
      ::-webkit-scrollbar-track {
        background: transparent;
      }
      ::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
      }

      /* Cart items */
      .item {
        display: flex;
        flex-direction: column;
        gap: 14px;
      }

      .emptyCart {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 3em 1em;
        gap: 12px;
        .cartIcon {
          font-size: 3.5em;
          opacity: 0.7;
        }
        h3 {
          font-weight: 300;
          font-size: 15px;
          text-align: center;
          color: #ebe0d3;
          margin: 0;
        }
      }
    }

    /* Transport cards */
    .transport-body {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 14px;
    }

    .transport-card {
      background: rgba(255, 255, 255, 0.07);
      border-radius: 10px;
      padding: 14px;

      .transport-card-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 7px;

        .transport-flag {
          font-size: 1.25em;
          line-height: 1;
          flex-shrink: 0;
        }

        h4 {
          margin: 0;
          font-size: 14px;
          font-weight: 500;
          color: white;
          line-height: 1.3;
        }
      }

      p {
        margin: 0;
        font-size: 13px;
        color: #c8e6c9;
        line-height: 1.65;
        font-weight: 300;
      }
    }

    /* Footer (cart total + checkout) */
    .modal-footer {
      padding: 14px 16px 20px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      flex-shrink: 0;

      .totalPrice {
        font-weight: 400;
        font-size: 17px;
        text-align: center;
        margin: 0 0 14px;
      }

      button {
        background: white;
        border: none;
        width: 100%;
        color: #202020;
        padding: 12px 14px;
        font-size: 16px;
        border-radius: 24px;
        font-family: "Poppins", cursive;
        cursor: pointer;
        transition: 0.3s;
        font-weight: 500;
        :hover {
          box-shadow: 0 0 14px 2px var(--shadowColor);
        }
        :active {
          transform: scale(0.98);
        }
      }
    }
  }

  /* ── Mobile breakpoint ── */
  @media (max-width: 640px) {
    padding: 0 5%;

    .logo {
      width: 44px;
    }

    /* Hide desktop nav; show hamburger + cart icons */
    .nav-menu {
      position: fixed;
      top: 0;
      right: -100%;
      width: 78%;
      max-width: 300px;
      height: 100dvh;
      background: var(--primaryBackgroundColor);
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 28px;
      padding: 0;
      z-index: 200;
      transition: right 0.3s ease;
      border-left: 1px solid var(--fontSecondaryColor);

      &.active {
        right: 0;
      }

      /* Hide the desktop cart icon — we show it in .mobile-icons */
      .cart-item {
        display: none;
      }

      li,
      .transport-btn {
        font-size: 18px;
      }
    }

    .mobile-icons {
      display: flex;
    }
  }
`;

export default Navbar;
